import { ProductConfig } from '@chegg/wt-checkout'

export const DEFAULT_PRICE = '$9.95'
export const DEFAULT_FREE_TRIAL = true
export const DEFAULT_PRICING_EXPERIMENT = 'BASE'
export const BASE_PRICE = 9.95

export const getProductConfig = (hasFreeTrial?: boolean): ProductConfig => {
  const itemId = hasFreeTrial ? 'CHGEbPlusMnthFT' : 'CHGEbPlusMnthNFTNew'
  return {
    itemId,
    productCode: 'EASYBIB',
    basePrice: BASE_PRICE,
  }
}
